import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
} from '@mui/material';
import { MdDelete } from "react-icons/md";
import axios from 'axios';
import { toast } from 'react-toastify';
const BE_URI = process.env.REACT_APP_BE_URI;

const EditWifiSectionModal = ({
  modalVisible,
  setModalVisible,
  selectedWifiSection,
  token,
  wifiSections,
  setWifiSections,
  getWifiSections,
  buttonColor,
}) => {
  const [name, setName] = useState(selectedWifiSection?.name || '');

  useEffect(() => {
    setName(selectedWifiSection?.name || '');
  }, [selectedWifiSection]);

  const handleUpdateWifiSection = async () => {
    try {
      const formData = {
        wifiSection: {
          _id: selectedWifiSection._id,
          name,
        },
      };
      const res = await axios.put(BE_URI + '/update-wifiSection', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        const updatedSections = wifiSections.filter(wf => wf._id !== selectedWifiSection._id);
        setWifiSections([...updatedSections, res.data.wifiSection].sort((a, b) => a.sequence - b.sequence));
        toast.success(`Successfully updated: ${res.data.wifiSection.name}!`);
        getWifiSections();
      } else {
        toast.error(`Error: ${res.data.message}`);
      }

      setModalVisible(false);
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      setModalVisible(false);
    }
  };

  const handleDeleteWifiSection = async () => {
    try {
      const res = await axios.post(BE_URI + '/delete-wifiSection', { id: selectedWifiSection._id }, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        setWifiSections(res.data.wifiSections);
        toast.success(`Successfully deleted: ${selectedWifiSection.name}!`);
      } else {
        toast.error(`Error: ${res.data.message}`);
      }

      setModalVisible(false);
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      setModalVisible(false);
    }
  };

  const isModified = name !== selectedWifiSection?.name;

  return (
    <Dialog open={modalVisible} onClose={() => setModalVisible(false)} fullWidth>
      <DialogTitle style={{ backgroundColor: buttonColor, color: '#FFFFFF', textAlign: 'center' }}>
        Edit Wifi-Section
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Name"
          placeholder="Full Name"
          value={name}
          onChange={e => setName(e.target.value)}
          margin="normal"
        />
        <IconButton onClick={handleDeleteWifiSection} style={{ color: buttonColor, marginTop: 20 }}>
          <MdDelete />
        </IconButton>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalVisible(false)} style={{ backgroundColor: buttonColor, color: '#FFFFFF' }}>
          CANCEL
        </Button>
        <Button
          onClick={isModified ? handleUpdateWifiSection : () => setModalVisible(false)}
          style={{ backgroundColor: buttonColor, color: '#FFFFFF' }}
        >
          {isModified ? 'Save' : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditWifiSectionModal;